import { semantic_colors, text_styles } from '../../foundation';
import { TooltipSize, TooltipKind } from './types';

export const tooltip_size_css: Record<TooltipSize, string> = {
  small: `
      padding: 2px 6px;
      ${text_styles.Caption_10_SemiBold};
    `,
  medium: `
      padding: 5px 6px;
      ${text_styles.Caption_11_SemiBold};
    `,
  large: `
      padding: 6px 10px;
      ${text_styles.Body_12_SemiBold};
    `,
};

export const tooltip_kind_color_css: Record<TooltipKind, string> = {
  neutral: semantic_colors.content.primary,
  accent: semantic_colors.accent.primary,
  negative: semantic_colors.state.negative,
};
